import { useEffect, useState } from 'react'
import { applyColorMode, detectColorMode, watchColorMode, type ColorMode } from '@/shared/office/theme'

/** Track the Office host theme and mirror it onto <html data-theme=...>. */
export function useColorMode(): ColorMode {
  const [colorMode, setColorMode] = useState<ColorMode>(() => detectColorMode())

  useEffect(() => {
    applyColorMode(colorMode)
  }, [colorMode])

  useEffect(() => watchColorMode(setColorMode), [])

  return colorMode
}
